import React, { Component } from 'react';
import { HashRouter, Redirect, Route, Switch } from 'react-router-dom';
import { observer } from 'mobx-react';
// import { renderRoutes } from 'react-router-config';
import './App.scss';
// import PrivateRoute from './helpers/PrivateRoute'
import Network, { logout, restoreSession, retrySession } from './helpers/Network'

const loading = () => <div className="animated fadeIn pt-3 text-center">Loading...</div>;

// Containers
const DefaultLayout = React.lazy(() => import('./containers/DefaultLayout'));

// Pages
const Login = React.lazy(() => import('./views/Pages/Login'));
const Page404 = React.lazy(() => import('./views/Pages/Page404'));
const Page500 = React.lazy(() => import('./views/Pages/Page500'));

class App extends Component {
  componentDidMount() {
    restoreSession().catch(() => null);
  }

  retrySession = () => {
    retrySession().catch(() => null);
  }

  endSession = () => {
    logout().catch(() => null);
  }

  render() {
    const authState = Network.authState.get();

    if (authState === 'booting') {
      return loading();
    }

    if (authState === 'unavailable') {
      return (
        <div className="app flex-row align-items-center justify-content-center">
          <div className="text-center p-4" role="alert">
            <p>{Network.authError.get() || 'Не удалось загрузить данные.'}</p>
            <button className="btn btn-primary mr-2" onClick={this.retrySession} type="button">
              Повторить
            </button>
            <button className="btn btn-link" onClick={this.endSession} type="button">
              Войти заново
            </button>
          </div>
        </div>
      );
    }

    return (
      <HashRouter>
          <React.Suspense fallback={loading()}>
            <Switch>
              <Route
                exact
                path="/login"
                name="Login Page"
                render={props => authState === 'authenticated'
                  ? <Redirect to="/" />
                  : <Login {...props}/>
                }
              />
              <Route exact path="/404" name="Page 404" render={props => <Page404 {...props}/>} />
              <Route exact path="/500" name="Page 500" render={props => <Page500 {...props}/>} />
              <Route
                path="/"
                name="Home"
                render={props => authState === 'authenticated'
                  ? <DefaultLayout {...props}/>
                  : <Redirect to="/login" />
                }
              />
            </Switch>
          </React.Suspense>
      </HashRouter>
    );
  }
}

export default observer(App);
